import { Api, Config } from './api'

export const ApiObterJustificativa = async (filtros) => {
  const params = new URLSearchParams()

  if (filtros.pagina) {
    params.append('pagina', filtros.pagina)
  }

  if (filtros.limite) {
    params.append('limite', filtros.limite)
  }

  if (filtros.porGrupo) {
    params.append('porGrupo', filtros.porGrupo)
  }

  const { data } = await Api.get(`/justificativas`, Config(params))
  return data
}
export const ApiObterDetalhesJustificativa = async (id) => {
  const { data } = await Api.get(`/justificativas/${id}`, Config())
  return data
}

export const ApiJustificarRegistro = async (payload) => {
  const { data } = await Api.put(`/justificativa-legal`, payload, Config())
  return data
}
